import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  binListing: {
    loading: false,
    error: null,
    data: null,
  },
  binDetails: {
    loading: false,
    error: null,
    data: null,
  },
  binDashboard: {
    loading: false,
    error: null,
    data: null,
  },
  binEvents: {
    loading: false,
    error: null,
    data: null,
  },
  createBin: {
    loading: false,
    error: null,
    data: null,
  },
  updateBin: {
    loading: false,
    error: null,
    data: null,
  },
  deleteBin: {
    loading: false,
    error: null,
    data: null,
  },
  updateFillLevel: {
    loading: false,
    error: null,
    data: null,
  },
  // Pickup requests
  pickupListing: {
    loading: false,
    error: null,
    data: null,
  },
  pickupDetails: {
    loading: false,
    error: null,
    data: null,
  },
  pickupCalendar: {
    loading: false,
    error: null,
    data: null,
  },
  createPickup: {
    loading: false,
    error: null,
    data: null,
  },
  updatePickup: {
    loading: false,
    error: null,
    data: null,
  },
};

const binsSlice = createSlice({
  name: "bins",
  initialState,
  reducers: {
    // Bin Listing
    binListingStart: (state) => {
      state.binListing.loading = true;
      state.binListing.error = null;
    },
    binListingSuccess: (state, action) => {
      state.binListing.loading = false;
      state.binListing.data = action.payload;
      state.binListing.error = null;
    },
    binListingFailure: (state, action) => {
      state.binListing.loading = false;
      state.binListing.error = action.payload;
    },
    binListingReset: (state) => {
      state.binListing = initialState.binListing;
    },

    // Bin Details
    binDetailsStart: (state) => {
      state.binDetails.loading = true;
      state.binDetails.error = null;
    },
    binDetailsSuccess: (state, action) => {
      state.binDetails.loading = false;
      state.binDetails.data = action.payload;
      state.binDetails.error = null;
    },
    binDetailsFailure: (state, action) => {
      state.binDetails.loading = false;
      state.binDetails.error = action.payload;
    },
    binDetailsReset: (state) => {
      state.binDetails = initialState.binDetails;
    },

    // Bin Dashboard
    binDashboardStart: (state) => {
      state.binDashboard.loading = true;
      state.binDashboard.error = null;
    },
    binDashboardSuccess: (state, action) => {
      state.binDashboard.loading = false;
      state.binDashboard.data = action.payload;
      state.binDashboard.error = null;
    },
    binDashboardFailure: (state, action) => {
      state.binDashboard.loading = false;
      state.binDashboard.error = action.payload;
    },
    binDashboardReset: (state) => {
      state.binDashboard = initialState.binDashboard;
    },

    // Bin Events
    binEventsStart: (state) => {
      state.binEvents.loading = true;
      state.binEvents.error = null;
    },
    binEventsSuccess: (state, action) => {
      state.binEvents.loading = false;
      state.binEvents.data = action.payload;
      state.binEvents.error = null;
    },
    binEventsFailure: (state, action) => {
      state.binEvents.loading = false;
      state.binEvents.error = action.payload;
    },

    // Create Bin
    createBinStart: (state) => {
      state.createBin.loading = true;
      state.createBin.error = null;
      state.createBin.data = null;
    },
    createBinSuccess: (state, action) => {
      state.createBin.loading = false;
      state.createBin.data = action.payload;
      state.createBin.error = null;
    },
    createBinFailure: (state, action) => {
      state.createBin.loading = false;
      state.createBin.error = action.payload;
    },
    createBinReset: (state) => {
      state.createBin = initialState.createBin;
    },

    // Update Bin
    updateBinStart: (state) => {
      state.updateBin.loading = true;
      state.updateBin.error = null;
      state.updateBin.data = null;
    },
    updateBinSuccess: (state, action) => {
      state.updateBin.loading = false;
      state.updateBin.data = action.payload;
      state.updateBin.error = null;
    },
    updateBinFailure: (state, action) => {
      state.updateBin.loading = false;
      state.updateBin.error = action.payload;
    },
    updateBinReset: (state) => {
      state.updateBin = initialState.updateBin;
    },

    // Delete Bin
    deleteBinStart: (state) => {
      state.deleteBin.loading = true;
      state.deleteBin.error = null;
      state.deleteBin.data = null;
    },
    deleteBinSuccess: (state, action) => {
      state.deleteBin.loading = false;
      state.deleteBin.data = action.payload;
      state.deleteBin.error = null;
    },
    deleteBinFailure: (state, action) => {
      state.deleteBin.loading = false;
      state.deleteBin.error = action.payload;
    },
    deleteBinReset: (state) => {
      state.deleteBin = initialState.deleteBin;
    },

    // Update Fill Level
    updateFillLevelStart: (state) => {
      state.updateFillLevel.loading = true;
      state.updateFillLevel.error = null;
      state.updateFillLevel.data = null;
    },
    updateFillLevelSuccess: (state, action) => {
      state.updateFillLevel.loading = false;
      state.updateFillLevel.data = action.payload;
      state.updateFillLevel.error = null;
    },
    updateFillLevelFailure: (state, action) => {
      state.updateFillLevel.loading = false;
      state.updateFillLevel.error = action.payload;
    },
    updateFillLevelReset: (state) => {
      state.updateFillLevel = initialState.updateFillLevel;
    },

    // Pickup Listing
    pickupListingStart: (state) => {
      state.pickupListing.loading = true;
      state.pickupListing.error = null;
    },
    pickupListingSuccess: (state, action) => {
      state.pickupListing.loading = false;
      state.pickupListing.data = action.payload;
      state.pickupListing.error = null;
    },
    pickupListingFailure: (state, action) => {
      state.pickupListing.loading = false;
      state.pickupListing.error = action.payload;
    },
    pickupListingReset: (state) => {
      state.pickupListing = initialState.pickupListing;
    },

    // Pickup Details
    pickupDetailsStart: (state) => {
      state.pickupDetails.loading = true;
      state.pickupDetails.error = null;
    },
    pickupDetailsSuccess: (state, action) => {
      state.pickupDetails.loading = false;
      state.pickupDetails.data = action.payload;
      state.pickupDetails.error = null;
    },
    pickupDetailsFailure: (state, action) => {
      state.pickupDetails.loading = false;
      state.pickupDetails.error = action.payload;
    },
    pickupDetailsReset: (state) => {
      state.pickupDetails = initialState.pickupDetails;
    },

    // Pickup Calendar
    pickupCalendarStart: (state) => {
      state.pickupCalendar.loading = true;
      state.pickupCalendar.error = null;
    },
    pickupCalendarSuccess: (state, action) => {
      state.pickupCalendar.loading = false;
      state.pickupCalendar.data = action.payload;
      state.pickupCalendar.error = null;
    },
    pickupCalendarFailure: (state, action) => {
      state.pickupCalendar.loading = false;
      state.pickupCalendar.error = action.payload;
    },

    // Create Pickup
    createPickupStart: (state) => {
      state.createPickup.loading = true;
      state.createPickup.error = null;
      state.createPickup.data = null;
    },
    createPickupSuccess: (state, action) => {
      state.createPickup.loading = false;
      state.createPickup.data = action.payload;
      state.createPickup.error = null;
    },
    createPickupFailure: (state, action) => {
      state.createPickup.loading = false;
      state.createPickup.error = action.payload;
    },
    createPickupReset: (state) => {
      state.createPickup = initialState.createPickup;
    },

    // Update Pickup
    updatePickupStart: (state) => {
      state.updatePickup.loading = true;
      state.updatePickup.error = null;
      state.updatePickup.data = null;
    },
    updatePickupSuccess: (state, action) => {
      state.updatePickup.loading = false;
      state.updatePickup.data = action.payload;
      state.updatePickup.error = null;
    },
    updatePickupFailure: (state, action) => {
      state.updatePickup.loading = false;
      state.updatePickup.error = action.payload;
    },
    updatePickupReset: (state) => {
      state.updatePickup = initialState.updatePickup;
    },
  },
});

export const {
  binListingStart,
  binListingSuccess,
  binListingFailure,
  binListingReset,
  binDetailsStart,
  binDetailsSuccess,
  binDetailsFailure,
  binDetailsReset,
  binDashboardStart,
  binDashboardSuccess,
  binDashboardFailure,
  binDashboardReset,
  binEventsStart,
  binEventsSuccess,
  binEventsFailure,
  createBinStart,
  createBinSuccess,
  createBinFailure,
  createBinReset,
  updateBinStart,
  updateBinSuccess,
  updateBinFailure,
  updateBinReset,
  deleteBinStart,
  deleteBinSuccess,
  deleteBinFailure,
  deleteBinReset,
  updateFillLevelStart,
  updateFillLevelSuccess,
  updateFillLevelFailure,
  updateFillLevelReset,
  pickupListingStart,
  pickupListingSuccess,
  pickupListingFailure,
  pickupListingReset,
  pickupDetailsStart,
  pickupDetailsSuccess,
  pickupDetailsFailure,
  pickupDetailsReset,
  pickupCalendarStart,
  pickupCalendarSuccess,
  pickupCalendarFailure,
  createPickupStart,
  createPickupSuccess,
  createPickupFailure,
  createPickupReset,
  updatePickupStart,
  updatePickupSuccess,
  updatePickupFailure,
  updatePickupReset,
} = binsSlice.actions;

export default binsSlice.reducer;
